<template>
  <div v-if="visibleFilters.length" class="crm-active-filters">
    <button
      v-for="filter in visibleFilters"
      :key="filter.key"
      class="crm-filter-chip"
      type="button"
      @click="$emit('remove', filter.key)"
    >
      <span>{{ filter.label }}</span>
      <strong>{{ filter.value }}</strong>
      <i class="la la-times"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "CrmActiveFilters",
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibleFilters() {
      return this.filters.filter(
        (filter) =>
          filter &&
          filter.value !== null &&
          filter.value !== undefined &&
          filter.value !== "" &&
          filter.value !== "Todos"
      );
    },
  },
};
</script>

<style scoped>
.crm-active-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.crm-filter-chip {
  align-items: center;
  background: #eaf7ff;
  border: 1px solid #cceeff;
  border-radius: 6px;
  color: #25324b;
  display: inline-flex;
  font-size: 12px;
  gap: 6px;
  max-width: 100%;
  min-height: 30px;
  padding: 5px 9px;
}

.crm-filter-chip span {
  color: #647084;
}

.crm-filter-chip strong {
  font-weight: 800;
  min-width: 0;
  overflow-wrap: anywhere;
}

.crm-filter-chip i {
  color: #0b87c9;
  font-size: 12px;
}
</style>
